import { HERO, type Hero } from '@aleaces/engine';

let uidCounter = 0;

/** SVG portrait markup, ported from the prototype. */
export function heroSVG(h: Hero, skinId?: string): string {
  const sk = h.skins.find((s) => s.id === skinId) ?? h.skins[0]!;
  const uid = h.id + '-' + sk.id + '-' + (uidCounter++ % 10000);
  const acc = sk.acc;
  let body = '';
  switch (h.id) {
    case 'brunhild': body = `
      <path d="M22 100 Q50 62 78 100Z" fill="#5a3a1e"/>
      <rect x="36" y="58" width="28" height="16" rx="4" fill="${acc}"/>
      <circle cx="50" cy="46" r="17" fill="#e8b08a"/>
      <path d="M33 44 Q35 24 50 24 Q65 24 67 44 L67 40 Q60 30 50 30 Q40 30 33 40Z" fill="${acc}"/>
      <path d="M32 46 Q28 70 36 84 Q40 70 38 50Z M68 46 Q72 70 64 84 Q60 70 62 50Z" fill="${acc}"/>
      <circle cx="43" cy="46" r="2.2" fill="#2a1a10"/><circle cx="57" cy="46" r="2.2" fill="#2a1a10"/>
      <circle cx="40" cy="53" r="3" fill="#e08a7a" opacity=".6"/><circle cx="60" cy="53" r="3" fill="#e08a7a" opacity=".6"/>
      <path d="M44 57 Q50 61 56 57" stroke="#7a3a2a" stroke-width="1.6" fill="none" stroke-linecap="round"/>
      <path d="M40 34 L60 34" stroke="#3a2412" stroke-width="3" stroke-linecap="round"/>`; break;
    case 'faelan': body = `
      <path d="M20 100 Q50 60 80 100Z" fill="#2a3070"/>
      <path d="M38 62 L50 78 L62 62Z" fill="${acc}" opacity=".9"/>
      <path d="M34 40 Q28 70 34 90 L44 62Z M66 40 Q72 70 66 90 L56 62Z" fill="#dfe6f5"/>
      <circle cx="50" cy="46" r="16" fill="#f1dcc9"/>
      <path d="M34 46 L24 38 L36 40Z M66 46 L76 38 L64 40Z" fill="#f1dcc9"/>
      <path d="M34 42 Q36 26 50 26 Q64 26 66 42 Q58 34 50 36 Q42 34 34 42Z" fill="#dfe6f5"/>
      <path d="M36 32 L50 27 L64 32" stroke="${acc}" stroke-width="2" fill="none"/><circle cx="50" cy="27" r="2.5" fill="${acc}"/>
      <path d="M42 44 L47 46 M53 46 L58 44" stroke="#2a2a4a" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M45 56 Q50 58 55 56" stroke="#8a5a5a" stroke-width="1.4" fill="none" stroke-linecap="round"/>`; break;
    case 'grokk': body = `
      <path d="M14 100 Q50 58 86 100Z" fill="#4a3220"/>
      <rect x="30" y="60" width="40" height="8" rx="3" fill="#8a8a92"/>
      <circle cx="50" cy="46" r="19" fill="#6a9a48"/>
      <path d="M44 28 Q50 8 56 28Z" fill="${acc}"/>
      <path d="M40 60 L42 68 L46 60Z M60 60 L58 68 L54 60Z" fill="#f4efe0"/>
      <path d="M38 40 L46 43 M62 40 L54 43" stroke="#1e2a10" stroke-width="2.4" stroke-linecap="round"/>
      <circle cx="44" cy="46" r="2.2" fill="#1e2a10"/><circle cx="57" cy="46" r="2.2" fill="#1e2a10"/>
      <path d="M62 30 L66 44" stroke="#3a4a24" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M42 58 Q50 55 58 58" stroke="#2a3a14" stroke-width="1.8" fill="none"/>
      <path d="M31 44 L26 36 L34 40Z M69 44 L74 36 L66 40Z" fill="#6a9a48"/>`; break;
    case 'pippa': body = `
      <path d="M24 100 Q50 66 76 100Z" fill="#7a4a2a"/>
      <path d="M36 70 L50 82 L64 70Z" fill="${acc}"/>
      <circle cx="50" cy="48" r="17" fill="#f2c8a0"/>
      <circle cx="36" cy="40" r="7" fill="#6b3a1e"/><circle cx="43" cy="32" r="7" fill="#6b3a1e"/><circle cx="52" cy="29" r="7" fill="#6b3a1e"/><circle cx="61" cy="33" r="7" fill="#6b3a1e"/><circle cx="66" cy="42" r="6" fill="#6b3a1e"/>
      <path d="M32 36 Q50 30 68 36" stroke="${acc}" stroke-width="4" fill="none"/>
      <circle cx="44" cy="48" r="2.4" fill="#2a1a10"/><circle cx="56" cy="48" r="2.4" fill="#2a1a10"/>
      <circle cx="40" cy="55" r="1" fill="#a06a4a"/><circle cx="44" cy="57" r="1" fill="#a06a4a"/><circle cx="57" cy="57" r="1" fill="#a06a4a"/><circle cx="61" cy="55" r="1" fill="#a06a4a"/>
      <path d="M44 59 Q50 64 56 59" stroke="#8a3a2a" stroke-width="1.6" fill="none" stroke-linecap="round"/>`; break;
    case 'aldric': body = `
      <path d="M18 100 Q50 58 82 100Z" fill="#8a8a92"/>
      <path d="M36 66 L50 80 L64 66Z" fill="${acc}"/>
      <circle cx="50" cy="48" r="17" fill="#e8c4a0"/>
      <path d="M31 46 Q31 22 50 22 Q69 22 69 46 L64 46 Q64 30 50 30 Q36 30 36 46Z" fill="#cfd3dc"/>
      <path d="M31 46 L69 46 L66 52 L34 52Z" fill="#cfd3dc"/>
      <path d="M46 20 L50 8 L54 20Z" fill="${acc}"/>
      <path d="M40 58 Q50 70 60 58 L60 62 Q50 72 40 62Z" fill="#d6a95a"/>
      <circle cx="44" cy="48" r="2" fill="#2a3a5a"/><circle cx="56" cy="48" r="2" fill="#2a3a5a"/>
      <path d="M45 57 Q50 60 55 57" stroke="#8a5a3a" stroke-width="1.4" fill="none"/>`; break;
    case 'zizzle': body = `
      <path d="M26 100 Q50 68 74 100Z" fill="#5a3a2a"/>
      <rect x="40" y="64" width="20" height="10" rx="3" fill="#b8742a"/>
      <circle cx="50" cy="48" r="15" fill="#7fbf6a"/>
      <path d="M36 44 L18 34 L34 50Z M64 44 L82 34 L66 50Z" fill="#7fbf6a"/>
      <path d="M40 30 L36 18 L46 28 M48 28 L50 14 L54 28 M58 28 L66 18 L62 32" fill="${acc}" stroke="${acc}" stroke-width="2" stroke-linejoin="round"/>
      <circle cx="43" cy="44" r="6" fill="#3a2a1a" stroke="#c9a04a" stroke-width="2"/><circle cx="57" cy="44" r="6" fill="#3a2a1a" stroke="#c9a04a" stroke-width="2"/>
      <circle cx="43" cy="44" r="2.5" fill="#ffe680"/><circle cx="57" cy="44" r="2.5" fill="#ffe680"/>
      <path d="M43 57 Q50 62 57 57" stroke="#2a4a1a" stroke-width="1.6" fill="none"/>
      <path d="M46 58 L47 61 M53 58 L52 61" stroke="#f4efe0" stroke-width="1.6"/>`; break;
  }
  return `<svg viewBox="0 0 100 100" aria-label="${h.name}"><defs><radialGradient id="g${uid}" cx="50%" cy="35%" r="70%"><stop offset="0" stop-color="${sk.bg[0]}"/><stop offset="1" stop-color="${sk.bg[1]}"/></radialGradient></defs><circle cx="50" cy="50" r="50" fill="url(#g${uid})"/>${body}</svg>`;
}

export function heroSvgById(heroId: string, skinId?: string): string {
  const h = HERO[heroId];
  return h ? heroSVG(h, skinId) : '';
}
